import { IconChevronDown, IconPlus } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { ReportingFilters } from "@/components/patterns/reporting-filters";
import { Button } from "@/components/ui/button";

export function DashboardFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-full min-w-0 flex-1 flex-col gap-[14px] px-6 pb-5 pt-[22px]">
      {children}
    </div>
  );
}

export function DashboardHeading({
  aiMasterOn,
  onManageAi,
  dataFreshness,
}: {
  aiMasterOn: boolean;
  onManageAi?: () => void;
  dataFreshness?: React.ReactNode;
}) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="flex min-h-[52px] shrink-0 flex-wrap items-start justify-between gap-x-6 gap-y-3">
      <div className="min-w-0 flex-1 basis-[180px]">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
          <h1 className="text-[24px] font-semibold leading-[30px] tracking-[-0.025em] text-ink">
            {t("overview.title")}
          </h1>
          {dataFreshness}
        </div>
        <p className="mt-0.5 text-[12px] leading-[18px] text-muted-foreground">
          {t("overview.subtitle")}
        </p>
      </div>
      <div className="flex max-w-full flex-col items-end gap-3">
        <ReportingFilters />
        {aiMasterOn ? (
          <button
            type="button"
            disabled={!onManageAi}
            onClick={onManageAi}
            className="mt-[3px] flex h-7 items-center gap-2 rounded-full border border-green/20 bg-green/5 py-0 pl-3 pr-2.5 text-[11px] font-medium text-green-11 outline-none transition-[background-color,border-color] duration-150 enabled:cursor-pointer enabled:hover:border-green/40 enabled:hover:bg-green/[0.07] enabled:focus-visible:ring-2 enabled:focus-visible:ring-ring enabled:focus-visible:ring-offset-2 disabled:cursor-default"
          >
            <span className="size-1.5 rounded-full bg-green" />
            {t("overview.aiEnabledBadge")}
            {onManageAi ? <IconChevronDown className="size-3" stroke={1.8} /> : null}
          </button>
        ) : onManageAi ? (
          <Button size="sm" onClick={onManageAi}>
            <IconPlus aria-hidden />
            {t("aiActivity.setupButton")}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
